import { AnonymousContextProvider } from '@do/seashell/components/AnonymousContext';
import { ExperimentationContextProvider } from '@do/seashell/components/ExperimentationContext';
import React from 'react';
import { FORCE_NEW_BRAND_DESIGN } from '../constants';
import LoadNewBrandDesignExperiment from './LoadNewBrandDesignExperiment';

const ExperimentationProviders: React.FC<{
  children: React.ReactNode;
  setIsNewBrandDesignEnabled: (isNewBrandDesignEnabled: boolean) => void;
}> = ({ children, setIsNewBrandDesignEnabled }) => {
  const experimentationContextProviderProps = {
    unauthenticated: true
  };

  return !FORCE_NEW_BRAND_DESIGN ? (
    <AnonymousContextProvider>
      <ExperimentationContextProvider {...experimentationContextProviderProps}>
        {children}
        <LoadNewBrandDesignExperiment
          setIsNewBrandDesignEnabled={setIsNewBrandDesignEnabled}
        />
      </ExperimentationContextProvider>
    </AnonymousContextProvider>
  ) : (
    <>{children}</>
  );
};

export default ExperimentationProviders;
